<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <PageHeader/>

        <div class="container">
          <Coupons/>

          <div class="row mt-4">
            <div class="col-sm-9">
              <ProductList/>
            </div>

            <div class="col-sm-3">
              <ShoppingCart/>
            </div>
          </div>
        </div>
        </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import PageHeader from './../Shared/PageHeader'
import Coupons from './Coupons'
import ProductList from './products/ProductList'
import ShoppingCart from './shopping-cart/ShoppingCart'

export default {
  name: 'Shop',
  components: {
    PageHeader,
    Coupons,
    ProductList,
    ShoppingCart
  }
}
</script>
